import { Component, OnInit } from '@angular/core';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { SelectItem } from 'primeng/api';
import { FonteDados } from '../../fonte-dados/fonte-dados.model';
import { FonteDadosService } from '../../fonte-dados/fonte-dados.service';
import { OrgaoJulgador } from '../../orgao-julgador/orgao-julgador.model';
import { OrgaoJulgadorService } from '../../orgao-julgador/orgao-julgador.service';
import { OrgaoJustica } from '../../orgao-justica/orgao-justica.model';
import { OrgaoJusticaService } from '../../orgao-justica/orgao-justica.service';
import { SelectItemService } from '../../services/select-item.service';
import { Usuario } from '../../usuario/usuario.model';
import { UsuarioService } from '../../usuario/usuario.service';
import { UsuarioPermissao } from '../usuario-permissao.model';
import { UsuarioPermissaoService } from '../usuario-permissao.service';
import { Frm } from '../../components/frm/frm.interface';
import { OrgaoJulgadorColegiadoLocalService } from '../../orgao-julgador-colegiado-local/orgao-julgador-colegiado-local.service';
import { OrgaoJulgadorColegiadoLocal } from '../../orgao-julgador-colegiado-local/orgao-julgador-colegiado-local.model';
import { NovoUsuarioSistema } from '../../usuario/novo-usuario-sistema.model';
import { DataSourceRouted } from '../../util/data-source-routed';
import { PerfilService } from '../../perfil/perfil.service';

@Component({
  selector: 'app-usuario-permissao-frm',
  templateUrl: './usuario-permissao-frm.component.html',
  styleUrls: ['./usuario-permissao-frm.component.css'],
})
export class UsuarioPermissaoFrmComponent implements OnInit, Frm<UsuarioPermissao, number> {
  mostrarCriaUsuarioSistemaModal: boolean;
  public login = '';
  public nomeSufixo = '';
  public senha = '';
  public loginInvalido = false;
  public carregando = false;
  public usuarioCriado: NovoUsuarioSistema;
  public ds: DataSourceRouted<Usuario, number>;

  public usuarioSugestoes: Usuario[];
  public abrangenciaItens: SelectItem[];
  public orgaoJusticaSugestoes: OrgaoJustica[];
  public usuarioPerfilSugestoes: SelectItem[] = [];
  public fonteDadosSugestoes: FonteDados[];
  public orgaoJulgadorSugestoes: OrgaoJulgador[];
  public orgaoJulgadorColegiadoLocalSugestoes: OrgaoJulgadorColegiadoLocal[];
  public nivelSigiloItens: SelectItem[];
  public error = false;
  public entidade: UsuarioPermissao;
  public mostrarImportarUsuarioSistemaModal: boolean;

  constructor(
    private service: UsuarioPermissaoService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService,
    private selectItemService: SelectItemService,
    private usuarioService: UsuarioService,
    private orgaoJusticaService: OrgaoJusticaService,
    private fonteDadosService: FonteDadosService,
    private orgaoJulgadorService: OrgaoJulgadorService,
    private orgaoJulgadorColegiadoLocalService: OrgaoJulgadorColegiadoLocalService,
    private perfilService: PerfilService
  ) {}

  ngOnInit(): void {
    this.nivelSigiloItens = this.selectItemService.getLimiteNivelSigiloItens();
    this.abrangenciaItens = this.selectItemService.getPermissaoAbrangenciaItens();
    this.entidade = this.service.newEntity();
  }

  abrirCriaUsuarioSistemaModal() {
    this.mostrarCriaUsuarioSistemaModal = true;
  }

  fecharCriaUsuarioSistemaModal() {
    this.mostrarCriaUsuarioSistemaModal = false;
    this.usuarioCriado = null;
    this.login = '';
    this.nomeSufixo = '';
    this.senha = '';
  }

  abrirImportarUsuarioSistemaModal() {
    this.mostrarImportarUsuarioSistemaModal = true;
  }

  fecharImportarUsuarioSistemaModal() {
    this.mostrarImportarUsuarioSistemaModal = false;
    this.usuarioCriado = null;
    this.login = '';
  }

  salvar(): void {
    this.progressoService.modal();
    this.service
      .salvar(this.entidade)
      .then((usuarioPermissao) => {
        this.entidade = usuarioPermissao;
        this.progressoService.fechar();
        this.mensagemService.addSucesso('Sucesso', 'O usuarioPermissao foi salvo com sucesso');
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao salvar a usuarioPermissao', resposta.error);
        this.progressoService.fechar();
      });
  }

  public importarUsuarioSistema() {
    this.carregando = true;
    this.usuarioService
      .importarUsuarioSistema(this.login)
      .then((resposta) => {
        this.carregando = false;
        this.entidade.usuario = resposta.usuario;
        this.mensagemService.addSucesso('Sucesso', 'O usuário foi importado com sucesso');
      })
      .catch((resposta) => {
        this.carregando = false;
        this.mensagemService.addErro('Erro:', resposta.error);
      });
  }

  criarUsuarioSistema() {
    this.carregando = true;
    const nomeCompleto = `Sistema ${this.nomeSufixo}`;
    this.usuarioService
      .inserirNovoUsuarioSistema({ login: this.login, nome: nomeCompleto, senha: this.senha })
      .then((resposta) => {
        this.carregando = false;
        this.usuarioCriado = resposta;
        this.entidade.usuario = resposta.usuario;
        this.carregando = false;
        this.fecharCriaUsuarioSistemaModal();
        this.mensagemService.addSucesso('Sucesso', 'O usuário foi salvo com sucesso');
        this.progressoService.fechar();
      })
      .catch((resposta) => {
        this.carregando = false;
        this.mensagemService.addErro('Erro:', resposta.error);
      });
  }

  iniciarInsercao(): void {}

  iniciarAlteracao(entidade: UsuarioPermissao): void {
    this.entidade = entidade;

    this.usuarioPerfilSugestoes.push({
      label: this.entidade.perfil.nome,
      value: this.entidade.perfil,
    });
  }

  iniciarAlteracaoPorId(id: number): void {
    this.progressoService.modal();
    this.service
      .recuperarPorId(id)
      .then((usuarioPermissao) => {
        this.progressoService.fechar();
        this.iniciarAlteracao(usuarioPermissao);
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao recuperar o parametro para edição', resposta.error);
      });
  }

  validarLogin() {
    const regex = /^[a-z0-9_-]*$/;
    const cpfRegex = /\d{11}/;
    this.loginInvalido = !regex.test(this.login) || cpfRegex.test(this.login);
  }

  validarFormulario(): boolean {
    this.validarLogin();
    return (
      !this.loginInvalido && this.login.trim().length > 0 && this.nomeSufixo.trim().length > 0 && this.senha.trim().length > 0
    );
  }

  public onCompleteUsuario(termo: string) {
    this.usuarioService
      .recuperarSugestoes(termo)
      .then((sugestoes) => (this.usuarioSugestoes = sugestoes))
      .catch((e) => this.mensagemService.addErro('Erro ao carregar a sugestões de usuários!', e.error));
  }

  public onCompleteOrgaoJustica(termo: string) {
    this.orgaoJusticaService
      .recuperarSugestoes(termo)
      .then((sugestoes) => (this.orgaoJusticaSugestoes = sugestoes))
      .catch((e) => this.mensagemService.addErro('Erro ao carregar a sugestões de orgão justiça!', e.error));
  }

  public onCompleteFonteDados(termo: string) {
    this.fonteDadosService
      .recuperarSugestoes(termo)
      .then((sugestoes) => (this.fonteDadosSugestoes = sugestoes))
      .catch((e) => this.mensagemService.addErro('Erro ao carregar a sugestões de fonte de dados!', e.error));
  }

  public onCompleteOrgaoJulgadorColegiado(termo: string) {
    this.orgaoJulgadorColegiadoLocalService
      .recuperarSugestoes(termo)
      .then((sugestoes) => (this.orgaoJulgadorColegiadoLocalSugestoes = sugestoes))
      .catch((e) => this.mensagemService.addErro('Erro ao carregar a sugestões de orgão julgador colegiado!', e.error));
  }

  public onCompleteOrgaoJulgador(termo: string) {
    this.orgaoJulgadorService
      .recuperarSugestoes(termo)
      .then((sugestoes) => (this.orgaoJulgadorSugestoes = sugestoes))
      .catch((e) => this.mensagemService.addErro('Erro ao carregar a sugestões de orgão julgador!', e.error));
  }

  public onCompleteUsuarioPerfil(tipoUsuario: string) {
    this.perfilService
      .recuperarItensPorTipoUsuario(tipoUsuario)
      .then(
        (perfis) => (this.usuarioPerfilSugestoes = perfis.map((perfil) => ({ label: perfil.nome, value: perfil } as SelectItem)))
      )
      .catch((e) => this.mensagemService.addErro('Erro ao carregar a sugestões de perfis!', e.error));
  }

  public onSelectUsuario(): void {
    if (this.entidade.usuario && this.entidade.usuario.tipo) {
      this.onCompleteUsuarioPerfil(this.entidade.usuario.tipo);
    } else {
      this.mensagemService.addErro('Erro', 'Tipo de usuário não encontrado.');
    }
  }
}
